const colors = {
  black: 'crimson',
  antique: 'antiquewhite'
};

export default colors;



// WEBPACK FOOTER //
// ./src/utils/colors.js